import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowRight, Copy } from "lucide-react";
import { toast } from "sonner";

const PaymentSuccessPage = () => {
  const location = useLocation();
  const { studentId, email, tempPassword, courseTitle, existingAccount } = location.state || {};

  const copy = (txt) => {
    navigator.clipboard.writeText(txt);
    toast.success("Copied to clipboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-2xl bg-white border border-slate-200 rounded-2xl shadow-sm p-10 text-center" data-testid="payment-success-card">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-10 h-10 text-green-600" />
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">Registration Successful!</h1>
        <p className="mt-3 text-slate-600">
          Your registration has been verified and saved successfully.
        </p>

        {studentId && (
          <div className="mt-8 bg-slate-50 border border-slate-200 rounded-xl p-6 text-left">
            <h3 className="font-heading font-bold text-slate-900 mb-4">
              {existingAccount ? "Registration Details" : "Your Login Credentials"}
            </h3>
            <p className="text-xs text-slate-500 mb-4">
              {existingAccount
                ? "This student was added under the existing account for this email. Use the current password for that email to log in."
                : "Save these securely. You'll need them to log in."}
            </p>
            <div className="space-y-3 text-sm">
              <Field label="Student ID" value={studentId} onCopy={() => copy(studentId)} />
              <Field label="Email" value={email} onCopy={() => copy(email)} />
              {!existingAccount && <Field label="Temporary Password" value={tempPassword} onCopy={() => copy(tempPassword)} sensitive />}
              {courseTitle && <Field label="Enrolled Program" value={courseTitle} />}
            </div>
          </div>
        )}

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/login" data-testid="success-goto-login-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-all">
            Go to Login <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 font-semibold transition-all">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, onCopy, sensitive }) => (
  <div className="flex items-center justify-between bg-white border border-slate-200 rounded-lg px-3 py-2">
    <div className="min-w-0">
      <div className="text-xs text-slate-500">{label}</div>
      <div className={`font-mono font-semibold text-slate-900 truncate ${sensitive ? "tracking-wider" : ""}`}>{value || "—"}</div>
    </div>
    {value && onCopy && (
      <button onClick={onCopy} className="p-2 hover:bg-slate-100 rounded-md text-slate-500 hover:text-slate-900 shrink-0">
        <Copy className="w-4 h-4" />
      </button>
    )}
  </div>
);

export default PaymentSuccessPage;

